import React from 'react';
import AppointmentForm from './Appointmentform';

const AddAppointment = ({ user, initialData = {}, onSave, onCancel }) => {
  // console.log("📥 AddAppointment received initialData:", initialData);

  const handleSaveAppointment = async (data) => {
  // console.log("Submitting appointment:", data);

  const payload = { appointment: data };

  const url = data.id 
    ? `/api/v1/appointments/${data.id}` 
    : `/api/v1/appointments`;

  const method = data.id ? "PATCH" : "POST";

  try {
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const errText = await res.text();
      console.error("❌ Failed:", errText);
      return;
    }

    const updated = await res.json();
    // console.log("✅ Saved:", updated);

    // refresh calendar after save
    if (typeof onSave === 'function') {
        onSave(); // navigateTo('calendar_app') is passed in from router config
      }
  } catch (err) {
    console.error("🚨 Network error:", err);
  }
};

  return (
  <div>
   <h2>{initialData.id ? "Update appointment" : "Book an appointment!"}</h2>
     <AppointmentForm 
      user={user}
      initialData={initialData}   
      onSave={handleSaveAppointment}
      onCancel={onCancel}
    />
  </div>
);
};

export default AddAppointment;
